const TOKENS_STORAGE_KEY = 'biotransac.auth.tokens';

export function buildBearerAuthHeader(): string | null {
  try {
    const raw = localStorage.getItem(TOKENS_STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as { accessToken?: string };
      if (parsed?.accessToken) return `Bearer ${parsed.accessToken}`;
    }
  } catch {
    // ignore
  }

  const token =
    localStorage.getItem('authToken') ??
    localStorage.getItem('accessToken') ??
    localStorage.getItem('token');

  return token ? `Bearer ${token}` : null;
}

